var map = {
	"./euro2024.webp": 1503,
	"./euro2024_title.svg": 1504,
	"./event-sport-bg.jpg": 1505,
	"./event-sport-bg.png": 1506,
	"./home-icon-active.webp": 1507,
	"./home-icon.webp": 1508,
	"./img_bg-uefa.png": 1509,
	"./live-icon-active.webp": 1510,
	"./master-bg.webp": 1511,
	"./me-icon-active.webp": 1512,
	"./product-overview-bg.webp": 1513,
	"./promos-icon-active.webp": 1514,
	"./sponsor-icon-active.webp": 1515,
	"./uefa-icon-active.webp": 1516,
	"./uefa-icon.webp": 1517,
	"./uefa-prediction.webp": 1518,
	"./wwr-img.webp": 1519
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 209;